<template>
  <v-card
    flat
  >
    <v-card-text>
      <v-form
        ref="form"
        v-model="complete"
        @submit.prevent
      >
        <password 
          v-model="oldPassword"
          label="Old Password"
        />

        <password 
          v-model="newPassword"
          label="New Password"
        />
      </v-form>
    </v-card-text>
  
    <v-card-actions>
      <v-btn
        type="submit"
        class="md-raised"
        :disabled="!isGood"
        :loading="busy"
        @click="doit"
      >
        Change Password
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Password from '../../../../shared/Password'

export default {
  components: { Password },
  data(){
    return {
      oldPassword: null,
      newPassword: null,
      complete: null,
      busy: false
    }
  },
  computed:{
    isGood(){return !!this.oldPassword && !!this.newPassword}
  },
  methods:{
    async doit(){
      this.busy = true
      let res = await this.api.post('/auth/change_password', {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      })
      if (res.passwordChanged) {
        this.$refs.form.reset()
      }
      this.busy = false
    }
  }
}
</script>